import { UnitOfMeasure } from "../contracts";

export const getUnitOfMeasureAbbreviation = (unitOfMeasure: UnitOfMeasure): string => {
    switch (unitOfMeasure) {
        case UnitOfMeasure.Each:
            return "ea";
        case UnitOfMeasure.Gram:
            return "g";
        case UnitOfMeasure.Kilogram:
            return "kg";
        case UnitOfMeasure.Millilitre:
            return "ml";
        case UnitOfMeasure.Litre:
            return "L";
    }
};
